// extracted by mini-css-extract-plugin
export default {"InfoBoxContainer":"_InfoBoxContainer--V4I0O","Link":"_Link--xyVIH"};